'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var toDashCase = exports.toDashCase = function toDashCase(str) {
  return str.replace(/([A-Z])/g, function ($1) {
    return '-' + $1.toLowerCase();
  });
};